import axios from 'axios'
import router from '../router';


// const url = 'https://39.100.87.127'
const url = 'https://www.3g48.com'
// const url = 'httpss://localhost:8443'
// const url = 'https://47.104.93.236'

const service = axios.create({
  timeout: 30000, // 请求超时时间
  baseURL: '/'
})

// Vue.prototype.$https = ajax
// console.log(Indicator,111)

service.interceptors.request.use(config => {
  // 拦截处理
  return config
}, error => {
  Promise.reject(error)
})

service.interceptors.response.use(resp => {
  return resp.status === 200 ? resp : {status: 400, msg: '网络错误'}
}, error => {
  if (error.response && error.response.status == 404) {
    // router.push('/src/views/blank.vue')
  }
  return Promise.reject(error.response)
})

export const getHome = () => service.get(``)
export const getProduct = (id) => service.get(`?Id=${id}`)
export const getLoginInfo = (userinfo) => service.post('', userinfo)
export function get(url, params = {}) {
  params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
  return service({
    url: url,
    method: 'get',
    headers: {},
    params,
  })
}

//封装post请求
export function post(url, data = {}) {
  //默认配置
  let sendObject = {
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  };
  sendObject.data = JSON.stringify(data);
  return service(sendObject)
}

//封装put方法 (resfulAPI常用)
export function put(url, data = {}) {
  return service({
    url: url,
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(data)
  })
}

//删除方法(resfulAPI常用)
export function deletes(url,data = {}) {
  return service({
    url: url,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(data)
  })
}

export {
  service,
  url
}
